import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const About = () => {
  const [activeTab, setActiveTab] = useState('biography');
  const { t } = useTranslation();

  // Icônes SVG inline (mêmes que dans Home)
  const Icons = {
    Cross: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 3c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
      </svg>
    ),
    Heart: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
      </svg>
    ),
    Star: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
      </svg>
    ),
    Users: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63C19.68 7.55 18.92 7 18.06 7h-.12c-.86 0-1.63.55-1.9 1.37l-.86 2.58c1.08.6 1.82 1.73 1.82 3.05v8h3z"/>
      </svg>
    ),
    Target: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/>
        <path d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
      </svg>
    ),
    Music: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
      </svg>
    ),
    Book: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
      </svg>
    ),
    Calendar: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
      </svg>
    ),
    Globe: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
      </svg>
    ),
    HandHelping: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 11h-1V3c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v8H8c-2.76 0-5 2.24-5 5v7h18v-7c0-2.76-2.24-5-5-5zm-5-8h2v8h-2V3zm8 18h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H9v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H5v-5c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3v5z"/>
      </svg>
    ),
    Worship: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
      </svg>
    ),
    School: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
      </svg>
    )
  };

  // Valeurs fondamentales
  const coreValues = [
    { 
      icon: <Icons.Cross />, 
      title: t('about.values.faith'), 
      description: t('about.values.faithDesc') 
    },
    { 
      icon: <Icons.Heart />, 
      title: t('about.values.love'), 
      description: t('about.values.loveDesc') 
    },
    { 
      icon: <Icons.Target />, 
      title: t('about.values.integrity'), 
      description: t('about.values.integrityDesc') 
    },
    { 
      icon: <Icons.Users />, 
      title: t('about.values.community'), 
      description: t('about.values.communityDesc') 
    },
    { 
      icon: <Icons.Music />, 
      title: t('about.values.excellence'), 
      description: t('about.values.excellenceDesc') 
    },
    { 
      icon: <Icons.Worship />, 
      title: t('about.values.worship'), 
      description: t('about.values.worshipDesc') 
    }
  ];

  // Sections de biographie
  const biographySections = [
    {
      id: 'early',
      title: t('about.biography.early.title'),
      content: t('about.biography.early.content'),
      highlight: t('about.biography.early.highlight')
    },
    {
      id: 'journey',
      title: t('about.biography.journey.title'),
      content: t('about.biography.journey.content'),
      highlight: t('about.biography.journey.highlight')
    },
    {
      id: 'ministry',
      title: t('about.biography.ministry.title'),
      content: t('about.biography.ministry.content'),
      highlight: t('about.biography.ministry.highlight')
    },
    {
      id: 'mission',
      title: t('about.biography.mission.title'),
      content: t('about.biography.mission.content'),
      highlight: t('about.biography.mission.highlight')
    }
  ];

  // Statistiques
  const stats = [
    { number: '10+', label: t('about.stats.years'), icon: <Icons.Calendar /> },
    { number: '3', label: t('about.stats.albums'), icon: <Icons.Music /> },
    { number: '100+', label: t('about.stats.songs'), icon: <Icons.Star /> },
    { number: '1', label: t('about.stats.book'), icon: <Icons.Book /> },
    { number: '1000+', label: t('about.stats.lives'), icon: <Icons.Users /> },
    { number: '24/7', label: t('about.stats.worship'), icon: <Icons.Worship /> }
  ];

  // Objectifs du ministère
  const ministryGoals = [
    {
      icon: <Icons.Music />,
      title: t('about.goals.production'),
      description: t('about.goals.productionDesc')
    },
    {
      icon: <Icons.School />,
      title: t('about.goals.training'),
      description: t('about.goals.trainingDesc')
    },
    {
      icon: <Icons.Globe />,
      title: t('about.goals.expansion'),
      description: t('about.goals.expansionDesc')
    },
    {
      icon: <Icons.HandHelping />,
      title: t('about.goals.social'),
      description: t('about.goals.socialDesc')
    }
  ];

  const activeSection = biographySections.find(section => section.id === activeTab) || biographySections[0];

  return (
    <div className="min-h-screen bg-black text-white pt-24">
      {/* Hero Section */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black z-10"></div>
        <div 
          className="absolute inset-0 z-0 opacity-20"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        
        <div className="container mx-auto px-4 relative z-20 py-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-5xl md:text-7xl font-bold mb-6 font-serif">
              {t('about.title')} <span className="text-yellow-600">{t('about.titleHighlight')}</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
              {t('about.subtitle')}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Photo d'Esaie + Introduction */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="relative max-w-m mx-auto lg:max-w-md mr-16 pl-12"
            >
              <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-yellow-500/30">
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
  src="/assets/images/photoclm.jpg"
  alt={t('about.photoAlt')}
  className="w-full h-full object-cover hover:scale-110 transition-transform duration-700 transform-gpu"
  style={{
    minHeight: '600px',
    maxHeight: '800px'
  }}
/>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                </div>
                
                <div className="absolute bottom-3 left-3 right-3 p-3 bg-black/70 backdrop-blur-sm rounded-lg border border-white/10">
                  <div className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-yellow-500/20 rounded flex items-center justify-center">
                      <Icons.Cross className="w-3 h-3 text-yellow-600" />
                    </div>
                    <div>
                      <p className="text-white font-semibold text-sm ">{t('about.name')}</p>
                    </div>
                  </div>
                </div>
                
                <div className="absolute -top-2 -right-2 w-10 h-10 bg-yellow-500/10 rounded-full blur-md"></div>
                <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-yellow-500/10 rounded-full blur-md"></div>
                <div className="absolute inset-0 border border-white/5 rounded-2xl pointer-events-none"></div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="flex flex-wrap items-center gap-3 mb-6">
                <div className="flex items-center space-x-2 text-gray-300">
                  <Icons.Cross className="w-4 h-4 text-yellow-600" />
                  <span className="font-medium">{t('about.roles.christianArtist')}</span>
                </div>
                <span className="text-gray-600">—</span>
                <div className="flex items-center space-x-2 text-gray-300">
                  <Icons.Music className="w-4 h-4 text-yellow-600" />
                  <span className="font-medium">{t('about.roles.musician')}</span>
                </div>
                <span className="text-gray-600">—</span>
                <div className="flex items-center space-x-2 text-gray-300">
                  <svg className="w-4 h-4 text-yellow-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>
                  </svg>
                  <span className="font-medium">{t('about.roles.singer')}</span>
                </div>
                <span className="text-gray-600">—</span>
                <div className="flex items-center space-x-2 text-gray-300">
                  <Icons.Book className="w-4 h-4 text-yellow-600" />
                  <span className="font-medium">{t('about.roles.writer')}</span>
                </div>
                <span className="text-gray-600">—</span>
                <div className="flex items-center space-x-2 text-gray-300">
                  <Icons.Target className="w-4 h-4 text-yellow-600" />
                  <span className="font-medium">{t('about.roles.visionary')}</span>
                </div>
              </div>
              
              <div className="space-y-4 text-gray-300 leading-relaxed">
                <p className="text-justify">
                  {t('about.intro.paragraph1')}
                </p>
                
                <p className="text-justify">
                  {t('about.intro.paragraph2')}
                </p>
                
                <p className="text-justify">
                  {t('about.intro.paragraph3')}
                </p>
              </div>

              <div className="mt-8 grid grid-cols-2 gap-4">
                {[
                  { 
                    label: t('about.qualifications.musician'), 
                    icon: <Icons.Music className="w-5 h-5" />,
                    color: 'from-blue-900/30 to-blue-800/20'
                  },
                  { 
                    label: t('about.qualifications.author'), 
                    icon: <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                          </svg>,
                    color: 'from-green-900/30 to-green-800/20'
                  },
                  { 
                    label: t('about.qualifications.teacher'), 
                    icon: <Icons.Book className="w-5 h-5" />,
                    color: 'from-purple-900/30 to-purple-800/20'
                  },
                  { 
                    label: t('about.qualifications.leader'), 
                    icon: <Icons.Users className="w-5 h-5" />,
                    color: 'from-yellow-900/30 to-yellow-800/20'
                  }
                ].map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                    className={`p-4 bg-gradient-to-br ${item.color} rounded-xl border border-gray-800 hover:border-gray-700 transition-all duration-300 group`}
                  >
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 rounded-lg bg-gray-900/50 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <span className="text-yellow-600">
                          {item.icon}
                        </span>
                      </div>
                      <span className="text-sm text-gray-300 font-medium">{item.label}</span>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Statistiques */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold mb-4">
              {t('about.statsTitle')}
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              {t('about.statsSubtitle')}
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }}
                className="text-center p-6 bg-gray-900/30 rounded-2xl backdrop-blur-sm border border-gray-800"
              >
                <motion.div 
                  className="text-yellow-600 mb-4 inline-block"
                  whileHover={{ rotate: 360 }}
                  transition={{ duration: 0.6 }}
                >
                  {stat.icon}
                </motion.div>
                <div className="text-2xl md:text-3xl font-bold text-white mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-400 text-sm font-medium">
                  {stat.label}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Biographie Interactive */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold mb-4">
              {t('about.journeyTitle')}
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              {t('about.journeySubtitle')}
            </p>
          </motion.div>

          <div className="flex flex-wrap justify-center gap-2 mb-12">
            {biographySections.map((section) => (
              <motion.button
                key={section.id}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setActiveTab(section.id)}
                className={`px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
                  activeTab === section.id
                    ? 'bg-yellow-600 text-white'
                    : 'bg-gray-900 text-gray-300 hover:bg-gray-800'
                }`}
              >
                {section.title}
              </motion.button>
            ))}
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              className="max-w-4xl mx-auto"
            >
              <div className="bg-gradient-to-br from-gray-900/50 to-black/50 rounded-3xl p-8 md:p-12 border border-gray-800">
                <h3 className="text-2xl font-bold mb-6 text-white">
                  {activeSection.title}
                </h3>
                
                <p className="text-gray-300 text-lg leading-relaxed mb-8">
                  {activeSection.content}
                </p>

                <div className="p-4 bg-yellow-900/20 rounded-xl border border-yellow-800/30">
                  <div className="flex items-center space-x-3">
                    <Icons.Star className="w-5 h-5 text-yellow-600" />
                    <span className="text-yellow-500 font-medium">{activeSection.highlight}</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </section>

      {/* Valeurs Fondamentales */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold mb-4">
              {t('about.valuesTitle')}
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              {t('about.valuesSubtitle')}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {coreValues.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -10 }}
                className="bg-gradient-to-b from-gray-900 to-black rounded-3xl p-8 border border-gray-800 group hover:border-gray-700 transition-all duration-500"
              >
                <div className="flex items-center space-x-4 mb-6">
                  <div className="w-14 h-14 bg-gradient-to-br from-gray-800 to-black rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 border border-gray-700">
                    <motion.span 
                      className="text-yellow-500"
                      whileHover={{ rotate: 15 }}
                    >
                      {value.icon}
                    </motion.span>
                  </div>
                  <h3 className="text-xl font-bold text-white">
                    {value.title}
                  </h3>
                </div>
                
                <p className="text-gray-400 leading-relaxed">
                  {value.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Objectifs du Ministère */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold mb-4">
              {t('about.goalsTitle')}
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              {t('about.goalsSubtitle')}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {ministryGoals.map((goal, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }}
                className="text-center"
              >
                <div className="w-20 h-20 bg-gradient-to-br from-gray-800 to-black rounded-2xl flex items-center justify-center mx-auto mb-6 border border-gray-700">
                  <motion.span 
                    className="text-yellow-600 text-2xl"
                    whileHover={{ rotate: 360 }}
                    transition={{ duration: 0.6 }}
                  >
                    {goal.icon}
                  </motion.span>
                </div>
                
                <h3 className="text-xl font-bold text-white mb-4">
                  {goal.title}
                </h3>
                
                <p className="text-gray-400">
                  {goal.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="max-w-3xl mx-auto"
          >
            <div className="bg-gradient-to-b from-gray-900/50 to-black/50 rounded-3xl p-12 border border-gray-800">
              <Icons.Cross className="w-16 h-16 text-yellow-600 mx-auto mb-6" />
              
              <h2 className="text-4xl font-bold text-white mb-6">
                {t('about.cta.title')}
              </h2>
              
              <p className="text-xl text-gray-300 mb-8 leading-relaxed text-justify">
                {t('about.cta.subtitle')}
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="https://open.spotify.com/intl-fr/artist/3Wi2QtUBfyY54IdnbNzoT2?uid=toptrack2CSc7rsY7gfRmfR9ZMFgJ5&uri=spotify:track:2CSc7rsY7gfRmfR9ZMFgJ5" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <button className="px-8 py-4 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white rounded-xl font-semibold hover:shadow-2xl hover:shadow-yellow-500/20 transition-all duration-300">
                    {t('about.cta.button')}
                  </button>
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;